import axios from "axios";

const API = axios.create({ baseURL: process.env.REACT_APP_BASE_URL })
// const API = axios.create({ baseURL: "http://192.168.29.181" }) // Incorrect URL

// ------------------All Customer API's-------------------
export const allCustomerList = (formData, nextPage, searchCustomer, sortBy, orderBy) => API.get(`/admin/customers?limit=10&search=${searchCustomer}&next_page_parameters=${nextPage}&sort=${sortBy} ${orderBy}`, formData)
export const customerDetailAndOrdersAPI = (formData, id) => API.get(`/admin/customer-detail-and-order/${id}`, formData)
export const allCustomerListAll = (formData, queryString, endCursor, startCursor) => API.get(`/admin/customers-all?limit=10&queryString=${queryString}&endCursor=${endCursor}&startCursor=${startCursor}`, formData)
